import { createSelector } from 'reselect';

import { TAX_FORMS_REDUCER_KEY } from './taxFormsTypes';

export const getTaxFormsStore = (state) => state[TAX_FORMS_REDUCER_KEY];

// required default selectors
export const getResourcesById = (state) => getTaxFormsStore(state).resourcesById;
export const getLoadPending = (state) => getTaxFormsStore(state).loadPending;
export const getIsLoading = (state) => getTaxFormsStore(state).isLoading;
export const getError = (state) => getTaxFormsStore(state).error;
export const getLastSyncDate = (state) => getTaxFormsStore(state).lastSyncDate;

export const getTaxFormForId = (state, id) => getResourcesById(state).get(id);

export const getTaxForms = createSelector(getResourcesById, (formsById) =>
  formsById.toList().sortBy((form) => form.displayOrder),
);
